import { render } from "./TriangleSeparator.vue?vue&type=template&id=3ba6d6d6&scoped=true"
import script from "./TriangleSeparator.vue?vue&type=script&lang=js"
export * from "./TriangleSeparator.vue?vue&type=script&lang=js"

import "./TriangleSeparator.vue?vue&type=style&index=0&id=3ba6d6d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba6d6d6"]])

export default __exports__